<template>
	<div id="app">
		<div id="nav">
			<router-link class="logo" to="/"><img src="~whitebox-presentation/src/assets/img/logo.svg" alt="WhiteBox"></router-link>
			<div id="header" class="blank">
				<div class="title"><strong>White</strong>Box<div class="slogan">Marketing and Business Intelligence</div></div>
				<multiselect 
					class="dropdown"
					@input="setLanguage"
					:options="languages" 
					:value="language"
					:show-labels="false" 
					:allow-empty="false" 
					placeholder="Select language">
				</multiselect>
				<div class="bar">
					<router-link class="button" to="/">{{ translation[lang].menu.home }}&nbsp;<span><font-awesome-icon icon="home"/></span></router-link>
					<router-link class="button" to="/about">{{ translation[lang].menu.about }}&nbsp;<span><font-awesome-icon icon="fingerprint"/></span></router-link>
					<router-link class="button" to="/contacts">{{ translation[lang].menu.contacts }}&nbsp;<span><font-awesome-icon icon="paper-plane"/></span></router-link>
					<a class="button login" href="https://web.whitebox.pro/" target="_blank">{{ translation[lang].menu.dashboard }}&nbsp;<span><font-awesome-icon icon="user-circle"/></span></a>
				</div>
			</div>
		</div>
		<div id="main">
			<router-view/>
		</div>
	</div>
</template>

<script>
import { translation } from 'documents/translation.yml'
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'

export default {
	name: 'App',
	data() {
		return {
			language: 'English',
			translation,
		}
	},
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: 'Marketing and Business Intelligence',
		// all titles will be injected into this template
		titleTemplate: 'WhiteBox - %s'
    },
	methods: {
		...mapActions(['setLang', 'setDefaultLang']),
		...mapActions('demo', ['init']),
		setLanguage: function(language) {
			let lang = _.keys(translation).find(key => translation[key].language == language)
			if (translation[lang] && translation[lang].enabled) {
				console.log('Language:', lang)
				this.setLang(lang)
			} else {
				console.log('Language disabled:', lang)
			}
		}
	},
	computed: {
        ...mapState({
			lang: state => state.settings.lang,
		}),
		languages: () => {
			return _.keys(translation).map(key => translation[key].language)
		},
		isLargeDesktop: () => {
			return window.innerHeight < window.innerWidth && window.innerHeight > 1000
		}
	},
	created() {
        window.whitebox.init('analytics', analytics => {
			if (analytics && analytics.service.location) {
				let country = analytics.service.location.country.toLowerCase()
				if (translation[country] && translation[country].enabled){
					this.setDefaultLang(country)
				}
			}
		})
		this.init()
    }

}
</script>

<style lang="less">
@import url('~whitebox-presentation/src/assets/variables.less');
@import url('~whitebox-presentation/src/assets/reset.less');
@import url('~whitebox-presentation/src/assets/default.less');
@import url('~whitebox-presentation/src/assets/fonts.less');
@import url('~whitebox-presentation/src/assets/forms.less');
@import url('~whitebox-presentation/src/assets/components/switch.less');
@import url('~whitebox-presentation/src/assets/header.less');
@import url('~whitebox-presentation/src/assets/components/dropdown.less');

#nav {
	display: flex;
}

.bar {
	display: flex;
	width: 100%;
}

.logo {
	display: block;
	width: @nav;
	background-color: transparent
}

.logo img {
	margin: 2*@gap;
	width: @nav - 4*@gap;
	display: block;
}

#header {
	background: transparent;
	box-shadow: none;
	width: calc(100vw - @nav);
	.title {
		width: 250px;
		flex-shrink: 0;
	}
	.slogan {
		font-size: @font-size;
		margin-top: -6px;
		margin-left: 3px;
	}
}

.login {
	flex-shrink: 0;
}

</style>
